import { ParameterTypeModel } from "src/common";

export class ParameterTypeViewModel {
    value: any;
    isValid: any;
    getValue: any;
    options: ParameterTypeModel[];
}